import SkillBar from "./SkillBar";
import { TemplateCard, TemplateCardContent } from "./TemplateCard";
import ReactIcon from "../../../assets/react.svg";
import TypeIcon from "../../../assets/typescript-icon.svg";
import VSCIcon from "../../../assets/visual-studio-code.svg";
import NodeIcon from "../../../assets/nodejs-icon.svg";
import AWSIcon from "../../../assets/aws.svg";
import GraphQLIcon from "../../../assets/graphql.svg";
import JestIcon from "../../../assets/jest.svg";
import AzureIcon from "../../../assets/microsoft-azure.svg";
import ReduxIcon from "../../../assets/redux.svg";
import TailwindIcon from "../../../assets/tailwindcss-icon.svg";
import WebpackIcon from "../../../assets/webpack.svg";
import AntIcon from "../../../assets/ant-design.svg";
import MaterialIcon from "../../../assets/material-ui.svg";

const SkillsCard = () => (
  <TemplateCard grid>
    <TemplateCardContent title="Tech Stack">
      <img src={ReactIcon} className="w-14" />
      <img src={TypeIcon} className="w-14" />
      <img src={ReduxIcon} className="w-14" />
      <img src={JestIcon} className="w-14" />
      <img src={GraphQLIcon} className="w-14" />
      <img src={TailwindIcon} className="w-14" />
      <img src={AntIcon} className="w-14" />
      <img src={MaterialIcon} className="w-14" />
      <img src={WebpackIcon} className="w-14" />
      <img src={NodeIcon} className="w-14" />
      <img src={AWSIcon} className="w-14" />
      <img src={AzureIcon} className="w-14" />
    </TemplateCardContent>
    <TemplateCardContent title="Tools" column>
      <div></div>
    </TemplateCardContent>
  </TemplateCard>
);

export default SkillsCard;
